import { Button, Icon } from '@/kit';
import type { BreakoutStage, MoveTemplate } from '@/domains/types';

interface MoveCardProps {
  move: MoveTemplate;
  stage?: BreakoutStage;
  day: number;
  durationDays: number;
  onComplete: () => void;
  onSkip: () => void;
  onHard: () => void;
  disabled?: boolean;
}

export function MoveCard({
  move,
  stage,
  day,
  durationDays,
  onComplete,
  onSkip,
  onHard,
  disabled,
}: MoveCardProps) {
  return (
    <article className="rounded-sm border border-white/[0.12] bg-hottr-charcoal p-5 md:p-6">
      <header className="mb-4 flex flex-wrap items-center gap-2">
        <span className="text-[10px] font-extrabold uppercase tracking-hottr-stamp text-hottr-pink">
          Day {day} / {durationDays}
        </span>
        {stage && (
          <span className="text-[10px] font-semibold uppercase tracking-hottr-label text-white/48">
            {stage.title}
          </span>
        )}
      </header>

      <h2 className="font-display text-2xl font-black uppercase tracking-hottr-display text-white md:text-3xl">
        {move.title}
        <span className="text-hottr-pink">.</span>
      </h2>

      <p className="mt-4 text-[15px] leading-relaxed text-white/80">{move.body}</p>

      <p className="mt-4 border-l-2 border-hottr-pink/40 pl-3 text-[13px] text-white/55">
        {move.why}
      </p>

      <div className="mt-6 flex flex-col gap-2 sm:flex-row">
        <Button
          variant="primary"
          fullWidth
          disabled={disabled}
          onClick={onComplete}
          leading={<Icon name="check" className="text-[18px]" />}
        >
          Done
        </Button>
        <Button variant="secondary" fullWidth disabled={disabled} onClick={onHard}>
          Hard day
        </Button>
        <Button variant="tertiary" fullWidth disabled={disabled} onClick={onSkip}>
          Skip
        </Button>
      </div>
      <p className="mt-3 text-center text-[11px] text-white/40">
        Hard day and skip do not erase your Momentum.
      </p>
    </article>
  );
}
